import React from "react";
// import s from "./style.module.css";
import "./cycleStyle.css";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";

const CycleDiagramFR = ({ data, title, note, source, value }) => {
  const { ref, width, height, windowSize, inView } = useVizualisation();

  return (
    <Vizualisation
      title={title}
      note={note}
      source={source}
      ref={ref}
      size="large"
    >
      <svg viewBox="200 200 1200 500" width={width} height={(width * 9) / 16}>
        <g>
          <g id="input_data_ID">
            <circle class="st0" cx="564.36" cy="451.55" r="110.86" />
            <g>
              <text
                transform="matrix(1 0 0 1 470.1721 460.3134)"
                class="st1 st2 st3"
              >
                Données d’entrée
              </text>
            </g>
            <g>
              <path
                class="st0"
                d="M478.76,542.63C478.76,542.63,478.76,542.63,478.76,542.63c22.37,21.03,52.48,33.92,85.6,33.92
					c69.04,0,125-55.96,125-125s-55.96-125-125-125c-10.15,0-20.01,1.22-29.46,3.5"
              />
              <path
                class="st0"
                d="M440.98,471.7c2.25,13.89,6.79,27.01,13.22,38.97"
              />
              <path
                class="st0"
                d="M454.2,392.44c-6.43,11.96-10.97,25.08-13.22,38.97"
              />
              <path
                class="st0"
                d="M497.8,345.74c-6.82,4.3-13.2,9.24-19.05,14.74c0,0,0,0,0,0"
              />
            </g>
          </g>
          <g id="arrow_input_data">
            <g>
              <g>
                <line
                  class="st5"
                  x1="845.7"
                  y1="316.55"
                  x2="564.36"
                  y2="316.55"
                />
                <g>
                  <polygon
                    class="st1"
                    points="841.54,310.45 864.31,316.55 841.54,322.65 						"
                  />
                </g>
              </g>
            </g>
            <g>
              <path
                class="st6"
                d="M564.36,316.55c-12.49,0-24.58,1.7-36.05,4.88c3.03,8.68-1.2,18.32-9.81,21.88
					c-8.52,3.53-18.22-0.19-22.29-8.31c-10.05,5.89-19.27,13.04-27.45,21.23c1.96,1.72,3.58,3.88,4.65,6.45
					c3.69,8.92-0.54,19.14-9.47,22.84c-5.61,2.32-11.73,1.51-16.42-1.63c-8.78,15.13-14.71,32.12-17.04,50.23
					c6.44,0.42,12.4,4.38,15.04,10.74c3.69,8.92-0.54,19.14-9.47,22.84c-1.82,0.76-3.7,1.16-5.57,1.28
					c2.34,18.11,8.26,35.1,17.04,50.23c4.69-3.14,10.81-3.96,16.42-1.63c8.92,3.69,13.16,13.92,9.47,22.84
					c-1.07,2.57-2.69,4.74-4.65,6.45c24.44,24.51,58.25,39.68,95.6,39.68"
              />
            </g>
          </g>
          <g id="economic_activities_EA">
            <circle class="st7" cx="869.64" cy="451.55" r="110.86" />
            <g>
              <g>
                <path
                  class="st8"
                  d="M986.8,494.42c0.09,0,0.18,0.01,0.27,0.01c4.89-13.37,7.56-27.81,7.56-42.88s-2.68-29.5-7.57-42.88
						c-0.09,0-0.18,0.01-0.27,0.01"
                />
                <path
                  class="st8"
                  d="M965.24,371.04c-22.93-27.2-57.24-44.49-95.6-44.49c-69.04,0-125,55.96-125,125s55.96,125,125,125
						c38.36,0,72.67-17.29,95.6-44.49"
                />
              </g>
            </g>
            <g>
              <text transform="matrix(1 0 0 1 822.261 444.0427)">
                <tspan x="0" y="0" class="st2 st3">
                  Activités{" "}
                </tspan>
                <tspan x="-22" y="26" class="st2 st3">
                  économiques
                </tspan>
              </text>
            </g>
          </g>
          <g id="UPD_input_data_line">
            <line class="st9" x1="492.61" y1="281.7" x2="508.36" y2="318.99" />
          </g>
          <g id="UPD_input_data_bullet_1">
            <g>
              <circle class="st10" cx="511.81" cy="327.16" r="8.5" />
              <circle class="st1" cx="511.81" cy="327.16" r="5.49" />
            </g>
          </g>
          <g id="UPD_input_data_circle">
            <circle class="st11" cx="489.96" cy="275.44" r="6.8" />
          </g>
          <g id="UPD_User_provided_data">
            <g>
              <path
                class="st11"
                d="M491.19,262.43c-7.72-0.5-14.38,5.34-14.88,13.06c-0.11,1.65,0.09,3.25,0.52,4.76
					c-3.9,0.58-7.92,0.78-12.01,0.51c-30.86-2.02-54.24-28.68-52.22-59.54s28.67-54.24,59.54-52.22
					c30.86,2.02,54.24,28.68,52.22,59.54c-1.1,16.82-9.53,31.4-21.95,40.88C500.14,265.49,496.04,262.74,491.19,262.43z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M472.66,272.69c-2.4,0.21-4.85,0.24-7.32,0.07c-26.45-1.73-46.49-24.58-44.76-51.03
					c1.73-26.45,24.58-46.49,51.03-44.76s46.49,24.58,44.76,51.03c-0.87,13.34-7.12,25.05-16.5,33.16"
              />
            </g>
          </g>
          <g id="PD_input_data_bullet_1">
            <g>
              <circle class="st10" cx="457.25" cy="369.38" r="8.5" />
              <circle class="st1" cx="457.25" cy="369.38" r="5.49" />
            </g>
          </g>
          <g id="PD_input_data_line_1_">
            <line class="st9" x1="417.63" y1="340.59" x2="449.91" y2="365" />
          </g>
          <g id="PD_input_data_line"></g>
          <g id="PD_input_data_circle_1_">
            <circle class="st11" cx="412.82" cy="335.78" r="6.8" />
          </g>
          <g id="PD_public_data">
            <g>
              <path
                class="st11"
                d="M398.82,335.78c0-7.73,6.27-14,14-14c1.66,0,3.24,0.3,4.72,0.83c0.84-3.85,1.29-7.85,1.29-11.95
					c0-30.93-25.07-56-56-56c-30.93,0-56,25.07-56,56c0,30.93,25.07,56,56,56c16.85,0,31.96-7.46,42.22-19.24
					C401.29,344.91,398.82,340.63,398.82,335.78z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M410.27,317.96c0.36-2.38,0.55-4.82,0.55-7.3c0-26.51-21.49-48-48-48s-48,21.49-48,48s21.49,48,48,48
					c13.37,0,25.46-5.47,34.17-14.3"
              />
            </g>
          </g>
          <g id="big_data_analytics_and_AI_bullet">
            <g>
              <circle class="st10" cx="600.08" cy="316.55" r="8.5" />
              <circle class="st1" cx="600.08" cy="316.55" r="5.49" />
            </g>
          </g>
          <g id="big_data">
            <g>
              <line
                class="st14"
                x1="600.08"
                y1="285.24"
                x2="600.08"
                y2="308.05"
              />
              <line
                class="st14"
                x1="574.8"
                y1="285.24"
                x2="624.41"
                y2="285.24"
              />
            </g>
            <g>
              <text transform="matrix(1 0 0 1 562.2695 225.9198)">
                <tspan x="-3" y="0" class="st1 st12 st13">
                  Analyses de{" "}
                </tspan>
                <tspan x="-12.23" y="16" class="st1 st12 st13">
                  mégadonnées{" "}
                </tspan>
                <tspan x="-9.67" y="32" class="st1 st12 st13">
                  et intelligence{" "}
                </tspan>
                <tspan x="5.96" y="48" class="st1 st12 st13">
                  artificielle{" "}
                </tspan>
              </text>
            </g>
            <g>
              <text transform="matrix(1 0 0 1 675.1609 225.9203)">
                <tspan x="0" y="0" class="st1 st12 st13">
                  Internet des{" "}
                </tspan>
                <tspan x="10.51" y="16" class="st1 st12 st13">
                  objets et{" "}
                </tspan>
                <tspan x="-12.84" y="32" class="st1 st12 st13">
                  autres appareils{" "}
                </tspan>
                <tspan x="3.89" y="48" class="st1 st12 st13">
                  intelligents{" "}
                </tspan>
              </text>
            </g>
            <g>
              <text transform="matrix(1 0 0 1 782.033 193.9198)">
                <tspan x="0" y="0" class="st1 st12 st13">
                  Technologie{" "}
                </tspan>
                <tspan x="1.57" y="16" class="st1 st12 st13">
                  de registres{" "}
                </tspan>
                <tspan x="-0.38" y="32" class="st1 st12 st13">
                  numériques,{" "}
                </tspan>
                <tspan x="8.19" y="48" class="st1 st12 st13">
                  y compris{" "}
                </tspan>
                <tspan x="3.89" y="64" class="st1 st12 st13">
                  de chaînes{" "}
                </tspan>
                <tspan x="10.12" y="80" class="st1 st12 st13">
                  de blocs{" "}
                </tspan>
              </text>
            </g>
            <g></g>
          </g>
          <g id="IOT_bullet">
            <g>
              <circle class="st10" cx="713.63" cy="316.55" r="8.5" />
              <circle class="st1" cx="713.63" cy="316.55" r="5.49" />
            </g>
          </g>
          <g id="IOT">
            <g>
              <line
                class="st14"
                x1="713.63"
                y1="285.24"
                x2="713.63"
                y2="308.05"
              />
              <line
                class="st14"
                x1="688.35"
                y1="285.24"
                x2="737.95"
                y2="285.24"
              />
            </g>
          </g>
          <g id="digital_ledger_bullet">
            <g>
              <circle class="st10" cx="821.12" cy="316.55" r="8.5" />
              <circle class="st1" cx="821.12" cy="316.55" r="5.49" />
            </g>
          </g>
          <g id="digital_ledger">
            <path class="st19" d="M855.45,285.24" />
            <g>
              <line
                class="st14"
                x1="821.12"
                y1="285.24"
                x2="821.12"
                y2="308.05"
              />
              <line
                class="st14"
                x1="795.84"
                y1="285.24"
                x2="845.44"
                y2="285.24"
              />
            </g>
          </g>
          <g id="arrow_economic_activities">
            <g>
              <g>
                <path
                  class="st15"
                  d="M589.79,586.55h279.85c43.63,0,82.43-20.71,107.1-52.82c-4.5-3.17-7.44-8.39-7.44-14.31
						c0-9.67,7.84-17.5,17.5-17.5c2.66,0,5.18,0.61,7.44,1.68c6.7-16.02,10.4-33.6,10.4-52.04s-3.7-36.03-10.4-52.04
						c-2.26,1.06-4.77,1.68-7.44,1.68c-9.66,0-17.5-7.83-17.5-17.5c0-5.92,2.95-11.14,7.44-14.31
						c-24.68-32.12-63.47-52.82-107.1-52.82"
                />
                <g>
                  <polygon
                    class="st16"
                    points="593.95,592.65 571.19,586.55 593.95,580.45 						"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="data_observed"></g>
          <g id="ID_bullet_1">
            <g>
              <circle class="st10" cx="429.36" cy="451.55" r="8.5" />
              <circle class="st1" cx="429.36" cy="451.55" r="5.49" />
            </g>
          </g>
          <g id="ID_line">
            <line class="st9" x1="380.38" y1="451.55" x2="420.86" y2="451.55" />
          </g>
          <g id="ID_bullet_2">
            <g>
              <circle class="st9" cx="371.88" cy="451.55" r="8.5" />
              <circle class="st1" cx="371.88" cy="451.55" r="5.49" />
            </g>
          </g>
          <g id="ID_Inferred_data">
            <g>
              <path
                class="st17"
                d="M355.73,458.24c-3.69-8.92,0.54-19.14,9.47-22.84c1.57-0.65,3.18-1.04,4.8-1.22
					c-7.95-36.25-40.22-63.38-78.86-63.38c-44.6,0-80.75,36.15-80.75,80.75s36.15,80.75,80.75,80.75c38.63,0,70.9-27.13,78.86-63.37
					C363.85,468.25,358.26,464.35,355.73,458.24z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M359.59,431.8c-8.56-29.74-35.97-51.5-68.46-51.5c-39.35,0-71.25,31.9-71.25,71.25s31.9,71.25,71.25,71.25
					c32.5,0,59.9-21.76,68.46-51.5"
              />
            </g>
            <g>
              <text transform="matrix(1 0 0 1 260.5538 439.3254)">
                <tspan x="0" y="0" class="st1 st12 st13">
                  Données{" "}
                </tspan>
                <tspan x="-7.64" y="16" class="st1 st12 st13">
                  induites par{" "}
                </tspan>
                <tspan x="0.99" y="32" class="st1 st12 st13">
                  l’analyse{" "}
                </tspan>
              </text>
            </g>
            <g></g>
          </g>
          <g id="DO_bullet_1">
            <g>
              <circle class="st10" cx="457.25" cy="533.73" r="8.5" />
              <circle class="st1" cx="457.25" cy="533.73" r="5.49" />
            </g>
          </g>
          <g id="DO_line">
            <line class="st9" x1="420.94" y1="566.57" x2="451.24" y2="539.74" />
          </g>
          <g id="DO_bullet_2">
            <g>
              <circle class="st9" cx="414.57" cy="572.21" r="8.5" />
              <circle class="st1" cx="414.57" cy="572.21" r="5.49" />
            </g>
          </g>
          <g id="DO_data_observed">
            <g>
              <path
                class="st17"
                d="M406.91,587.92c-8.68-4.23-12.28-14.69-8.05-23.37c0.75-1.53,1.69-2.89,2.78-4.09
					c-29.98-21.87-72.13-20.79-101.06,4.82c-33.39,29.56-36.49,80.6-6.93,113.99c29.56,33.39,80.6,36.49,113.99,6.93
					c28.92-25.61,35.1-67.32,17.03-99.72C419.63,590.04,412.85,590.82,406.91,587.92z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M392.28,565.56c-26.13-16.59-61.07-14.71-85.39,6.83c-29.46,26.09-32.2,71.12-6.11,100.58
					c26.09,29.46,71.12,32.2,100.58,6.11c24.33-21.54,30.42-56,17.12-83.94"
              />
            </g>
            <g>
              <text transform="matrix(1 0 0 1 326.9245 580.7621)">
                <tspan x="-5" y="0" class="st1 st12 st13">
                  Données
                </tspan>
                <tspan x="-20.31" y="16" class="st1 st12 st13">
                  observées sur
                </tspan>
                <tspan x="-37.7" y="32" class="st1 st12 st13">
                  les utilisateurs, les
                </tspan>
                <tspan x="-13.7" y="48" class="st1 st12 st13">
                  objets et les
                </tspan>
                <tspan x="-37.19" y="64" class="st1 st12 st13">
                  processus, dans le
                </tspan>
                <tspan x="-34.8" y="80" class="st1 st12 st13">
                  cadre de l’activité
                </tspan>
                <tspan x="-18.48" y="96" class="st1 st12 st13">
                  économique
                </tspan>
              </text>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </g>
          <g id="data_observed_bullet"></g>
          <g id="big_data_cleaning">
            <g>
              <line
                class="st18"
                x1="716.69"
                y1="617.52"
                x2="716.69"
                y2="594.7"
              />
              <line
                class="st18"
                x1="741.98"
                y1="617.52"
                x2="692.37"
                y2="617.52"
              />
            </g>
            <g>
              <text transform="matrix(1 0 0 1 676.9653 637.163)">
                <tspan x="-7" y="0" class="st16 st12 st13">
                  Nettoyage et{" "}
                </tspan>
                <tspan x="-2.89" y="16" class="st16 st12 st13">
                  stockage de
                </tspan>
                <tspan x="-11.68" y="32" class="st16 st12 st13">
                  mégadonnées{" "}
                </tspan>
              </text>
            </g>
            <g></g>
          </g>
          <g id="big_data_cleaning_bullet">
            <g>
              <circle class="st19" cx="716.69" cy="586.2" r="8.5" />
              <circle class="st16" cx="716.69" cy="586.2" r="5.49" />
            </g>
          </g>
          <g id="BDD_economic_activities_bullet">
            <g>
              <circle cx="986.8" cy="383.68" r="5.49" />
            </g>
            <circle class="st18" cx="986.8" cy="383.68" r="8.5" />
          </g>
          <g id="better_data_driven_decision_BDDB">
            <g>
              <path
                class="st21"
                d="M1161.33,324.06c0-3.85,3.03-6.99,6.84-7.18c-1.02-10-4.16-19.36-8.94-27.67
					c-1.12,0.72-2.45,1.15-3.89,1.15c-3.98,0-7.2-3.22-7.2-7.2c0-2.27,1.05-4.29,2.69-5.61c-12.82-14.41-31.5-23.49-52.3-23.49
					c-38.66,0-70,31.34-70,70c0,5.13,0.57,10.12,1.61,14.94c1.84-0.66,3.82-1.04,5.89-1.04c9.66,0,17.5,7.83,17.5,17.5
					c0,6.07-3.09,11.42-7.79,14.55c12.83,14.73,31.71,24.05,52.78,24.05c20.8,0,39.48-9.08,52.3-23.49
					c-1.64-1.32-2.69-3.34-2.69-5.61c0-3.98,3.22-7.2,7.2-7.2c1.43,0,2.76,0.42,3.89,1.15c4.78-8.3,7.92-17.67,8.94-27.67
					C1164.36,331.05,1161.33,327.91,1161.33,324.06z"
              />
            </g>
            <g>
              <path
                class="st22"
                d="M1039.22,333.19c-0.45-2.98-0.69-6.02-0.69-9.13c0-33.14,26.86-60,60-60s60,26.86,60,60s-26.86,60-60,60
					c-16.72,0-31.83-6.84-42.71-17.87"
              />
            </g>
            <g>
              <text
                transform="matrix(1 0 0 1 1425.1646 207.7852)"
                class="st23 st20 st31"
              >
                {" "}
              </text>
            </g>
            <g>
              <text transform="matrix(1 0 0 1 1074.875 292.3618)">
                <tspan x="-4" y="0" class="st23 st12 st13">
                  Prise de{" "}
                </tspan>
                <tspan x="-10.11" y="16" class="st23 st12 st13">
                  meilleures{" "}
                </tspan>
                <tspan x="-6.56" y="32" class="st23 st12 st13">
                  décisions
                </tspan>
                <tspan x="-13.63" y="48" class="st23 st12 st13">
                  fondées sur
                </tspan>
                <tspan x="-18.93" y="64" class="st23 st12 st13">
                  des données{" "}
                </tspan>
              </text>
            </g>
          </g>
          <g id="DDM_economic_activities_bullet_1_">
            <g>
              <circle class="st18" cx="986.8" cy="519.42" r="8.5" />
              <circle cx="986.8" cy="519.42" r="5.49" />
            </g>
          </g>
          <g id="BDD_economic_activities_line">
            <line
              class="st24"
              x1="1028.61"
              y1="358.4"
              x2="994.01"
              y2="378.69"
            />
          </g>
          <g id="BDD_bullet">
            <circle class="st25" cx="1036.04" cy="355.46" r="8.5" />
            <circle class="st23" cx="1036.04" cy="355.46" r="5.49" />
          </g>
          <g id="innovative_products">
            <g>
              <path
                class="st21"
                d="M1239.56,423.11c0,7.73-6.27,14-14,14c-1.66,0-3.24-0.3-4.72-0.83c-0.84,3.85-1.29,7.85-1.29,11.95
					c0,30.93,25.07,56,56,56c30.93,0,56-25.07,56-56c0-30.93-25.07-56-56-56c-16.85,0-31.96,7.46-42.22,19.24
					C1237.08,413.97,1239.56,418.25,1239.56,423.11z"
              />
            </g>
            <g>
              <path
                class="st22"
                d="M1228.1,440.93c-0.36,2.38-0.55,4.82-0.55,7.3c0,26.51,21.49,48,48,48s48-21.49,48-48
					c0-26.51-21.49-48-48-48c-13.37,0-25.46,5.47-34.17,14.3"
              />
            </g>
          </g>
          <g id="innovative_products_circle">
            <circle class="st25" cx="1225.56" cy="423.11" r="6.8" />
          </g>
          <g id="innovative_products_line">
            <line
              class="st25"
              x1="1155.34"
              y1="364.96"
              x2="1220.75"
              y2="418.3"
            />
          </g>
          <g id="innovative_products_small_dot">
            <circle class="st23" cx="1155.34" cy="364.96" r="4.5" />
          </g>
          <g id="data_driven_matching_DDM">
            <g>
              <path
                class="st26"
                d="M1168.16,586.23c-3.81-0.19-6.84-3.33-6.84-7.18s3.03-6.99,6.84-7.18l0,0
					c-3.6-35.29-33.4-62.82-69.64-62.82c-21.07,0-39.95,9.32-52.78,24.05c4.69,3.14,7.79,8.48,7.79,14.55
					c0,9.67-7.84,17.5-17.5,17.5c-2.07,0-4.05-0.38-5.89-1.04c-1.05,4.82-1.61,9.81-1.61,14.94c0,38.66,31.34,70,70,70
					C1134.76,649.04,1164.57,621.51,1168.16,586.23L1168.16,586.23z"
              />
            </g>
            <g>
              <path
                class="st27"
                d="M1039.22,569.92c-0.45,2.98-0.69,6.02-0.69,9.13c0,33.14,26.86,60,60,60s60-26.86,60-60s-26.86-60-60-60
					c-16.72,0-31.83,6.84-42.71,17.87"
              />
            </g>
            <g>
              <text transform="matrix(1 0 0 1 1060.4412 570.1826)">
                <tspan x="-5" y="0" class="st28 st12 st13">
                  Appariement{" "}
                </tspan>
                <tspan x="-11.62" y="17" class="st28 st12 st13">
                  de la demande{" "}
                </tspan>
                <tspan x="14.79" y="34" class="st28 st12 st13">
                  et l’offre{" "}
                </tspan>
              </text>
            </g>
            <g></g>
          </g>
          <g id="DDM_economic_activities_line">
            <line
              class="st29"
              x1="1028.61"
              y1="544.71"
              x2="994.01"
              y2="524.01"
            />
          </g>
          <g id="DDM_economic_activities_bullet_2">
            <circle class="st30" cx="1036.04" cy="547.64" r="8.5" />
            <circle class="st28" cx="1036.04" cy="547.64" r="5.49" />
          </g>
          <g id="improved_intermediation">
            <g>
              <g>
                <path
                  class="st26"
                  d="M1230.95,585.24c3.47-6.91,0.68-15.32-6.23-18.79c-1.48-0.74-3.03-1.18-4.59-1.37
						c0.98-3.82,2.37-7.59,4.21-11.26c13.87-27.64,47.52-38.81,75.17-24.94c27.64,13.87,38.81,47.52,24.94,75.17
						c-13.87,27.64-47.52,38.81-75.17,24.94c-15.06-7.56-25.22-20.99-29.11-36.13C1224.65,592.29,1228.78,589.58,1230.95,585.24z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  class="st27"
                  d="M1228.71,564.17c0.74-2.29,1.67-4.56,2.78-6.77c11.89-23.69,40.73-33.26,64.43-21.38
						c23.69,11.89,33.26,40.73,21.38,64.43s-40.73,33.26-64.43,21.38c-11.95-6-20.3-16.31-24.13-28.1"
                />
              </g>
            </g>
            <g>
              <text transform="matrix(1 0 0 1 1246.3911 568.0013)">
                <tspan x="0" y="0" class="st28 st12 st13">
                  Meilleure{" "}
                </tspan>
                <tspan x="12.45" y="17" class="st28 st12 st13">
                  inter-{" "}
                </tspan>
                <tspan x="-4.01" y="34" class="st28 st12 st13">
                  médiation
                </tspan>
              </text>
            </g>
          </g>
          <g id="improved_intermediation_circle">
            <circle class="st30" cx="1219.45" cy="579.04" r="6.8" />
          </g>
          <g id="improved_inermediation_line">
            <line
              class="st30"
              x1="1168.53"
              y1="579.04"
              x2="1212.65"
              y2="579.04"
            />
          </g>
          <g id="improved_intermediation__small_dot">
            <circle class="st28" cx="1168.53" cy="579.04" r="4.5" />
          </g>
          <g id="quality_improvements">
            <g>
              <path
                class="st21"
                d="M1230.95,330.25c3.47-6.91,0.68-15.32-6.23-18.79c-1.48-0.74-3.03-1.18-4.59-1.37
					c0.98-3.82,2.37-7.59,4.21-11.26c13.87-27.64,47.52-38.81,75.17-24.94s38.81,47.52,24.94,75.17
					c-13.87,27.64-47.52,38.81-75.17,24.94c-15.06-7.56-25.22-20.99-29.11-36.13C1224.65,337.31,1228.78,334.59,1230.95,330.25z"
              />
            </g>
            <g>
              <path
                class="st22"
                d="M1228.71,309.19c0.74-2.29,1.67-4.56,2.78-6.77c11.89-23.69,40.73-33.26,64.43-21.38
					c23.69,11.89,33.26,40.73,21.38,64.43c-11.89,23.69-40.73,33.26-64.43,21.38c-11.95-6-20.3-16.31-24.13-28.1"
              />
            </g>
            <g>
              <text transform="matrix(1 0 0 1 1250.8081 445.0493)">
                <tspan x="-5" y="0" class="st23 st12 st13">
                  Produits
                </tspan>
                <tspan x="-9.12" y="16" class="st23 st12 st13">
                  innovants
                </tspan>
              </text>
            </g>
            <g>
              <text transform="matrix(1 0 0 1 1236.7522 319.0287)">
                <tspan x="5" y="-8" class="st23 st12 st13">
                  Améliora-
                </tspan>
                <tspan x="23" y="7" class="st23 st12 st13">
                  tions
                </tspan>
                <tspan x="0" y="22" class="st23 st12 st13">
                  qualitatives
                </tspan>
              </text>
            </g>
          </g>
          <g id="quality_improvements_circle">
            <circle class="st25" cx="1219.45" cy="324.06" r="6.8" />
          </g>
          <g id="quality_improvements_line">
            <line
              class="st25"
              x1="1168.53"
              y1="324.06"
              x2="1212.65"
              y2="324.06"
            />
          </g>
          <g id="quality_improvements_small_dot">
            <circle class="st23" cx="1168.53" cy="324.06" r="4.5" />
          </g>
          <g id="Layer_48"></g>
          <g id="lower_costs">
            <g>
              <path
                class="st21"
                d="M1239.56,225.01c0-7.73-6.27-14-14-14c-1.66,0-3.24,0.3-4.72,0.83c-0.84-3.85-1.29-7.85-1.29-11.95
					c0-30.93,25.07-56,56-56c30.93,0,56,25.07,56,56c0,30.93-25.07,56-56,56c-16.85,0-31.96-7.46-42.22-19.24
					C1237.08,234.15,1239.56,229.87,1239.56,225.01z"
              />
            </g>
            <g>
              <path
                class="st22"
                d="M1228.1,207.19c-0.36-2.38-0.55-4.82-0.55-7.3c0-26.51,21.49-48,48-48s48,21.49,48,48s-21.49,48-48,48
					c-13.37,0-25.46-5.47-34.17-14.3"
              />
            </g>
            <g>
              <text transform="matrix(1 0 0 1 1246.1807 197.4797)">
                <tspan x="-5" y="0" class="st23 st12 st13">
                  Réduction
                </tspan>
                <tspan x="-3.56" y="16" class="st23 st12 st13">
                  des coûts
                </tspan>
              </text>
            </g>
          </g>
          <g id="lower_costs_circle">
            <circle class="st25" cx="1225.56" cy="225.01" r="6.8" />
          </g>
          <g id="lower_costs_line">
            <line
              class="st25"
              x1="1155.34"
              y1="283.16"
              x2="1220.75"
              y2="229.82"
            />
          </g>
          <g id="BDD_bullet_1">
            <circle class="st23" cx="1155.34" cy="283.16" r="4.5" />
            <text transform="matrix(1 0 0 1 441.348 208.5607)">
              <tspan x="-5" y="0" class="st1 st12 st13">
                Données
              </tspan>
              <tspan x="-13.95" y="16" class="st1 st12 st13">
                fournies par{" "}
              </tspan>
              <tspan x="-8.1" y="32" class="st1 st12 st13">
                l’utilisateur
              </tspan>
            </text>
            <g>
              <text transform="matrix(1 0 0 1 334.1893 303.4697)">
                <tspan x="-3" y="0" class="st1 st12 st13">
                  Données
                </tspan>
                <tspan x="-4.95" y="16" class="st1 st12 st13">
                  publiques
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </svg>
    </Vizualisation>
  );
};

export default CycleDiagramFR;
